/* Connect existing selectors and contact forms. No cart API calls or automatic submission. */
(() => {
  const productInfo = document.querySelector('main product-info');
  const variantSelector = () => productInfo?.querySelector('product-variant-selects');
  const selectedOptions = () => Array.from(variantSelector()?.querySelectorAll('input[type="radio"]:checked, select') || []).map(input => input.value).filter(Boolean);
  const refreshSupport = () => {
    const support = productInfo?.querySelector('[data-sp-buying-support]');
    if (!support) return;
    const options = selectedOptions();
    const delivery = productInfo.querySelector('[data-sp-delivery]');
    if (delivery) {
      const selectedSize = options[Number(delivery.dataset.sizeIndex)] || '';
      const size = Number.parseFloat(selectedSize);
      const mode = !Number.isFinite(size) || size <= 0 ? 'custom' : delivery.dataset.motorized === 'true' ? (size > 120 ? 'sea' : 'air') : 'fixed';
      const timing = delivery.querySelector('[data-sp-delivery-timing]');
      const message = delivery.dataset[mode];
      if (timing && message && timing.textContent !== message) timing.textContent = message;
    }
    const configuration = options.join(' / ');
    const output = support.querySelector('[data-sp-configuration]');
    if (configuration && output.textContent !== configuration) output.textContent = configuration;
    document.querySelectorAll('[data-sp-enquiry]').forEach(link => {
    const url = new URL(link.getAttribute('href'), location.origin);
    url.searchParams.set('sp_product', support.dataset.productTitle);
    url.searchParams.set('sp_config', configuration || output.textContent.trim());
    url.searchParams.set('sp_url', support.dataset.productPath);
    if (link.href !== url.href) link.href = url.href;
    });
  };
  refreshSupport();
  if (productInfo) {
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; refreshSupport(); });
    }).observe(productInfo, {childList:true, subtree:true});
    productInfo.addEventListener('change', refreshSupport);
  }

  // Carry only product context through the link; customer details remain on the form.
  const contact = document.querySelector('#ContactForm');
  if (contact) {
    const params = new URLSearchParams(location.search);
    const title = (params.get('sp_product') || '').slice(0,200);
    const configuration = (params.get('sp_config') || '').slice(0,200);
    const path = (params.get('sp_url') || '').slice(0,300);
    const validPath = /^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?products\/[a-z0-9-]+$/.test(path);
    let filled = false;
    const product = contact.querySelector('[name="contact[product_or_page_optional]"]');
    const message = contact.querySelector('[name="contact[message]"]');
    if (title && validPath && product && !product.value) {
      product.value = title + ' — ' + location.origin + path;
      filled = true;
    }
    if (configuration && title && validPath && message && !message.value) {
      message.value = title + '\n' + configuration;
      filled = true;
    }
    const note = contact.querySelector('[data-sp-prefill-note]');
    if (note && filled) note.hidden = false;
  }

  const story = document.querySelector('.sp-story--floor-review');
  if (!story) return;
  story.addEventListener('input', event => {
    if (event.target.closest('.sp-story__enquiry')) event.target.dataset.spEdited = 'true';
  });
  story.addEventListener('change', event => {
    if (event.target.closest('.sp-story__enquiry')) event.target.dataset.spEdited = 'true';
    if (event.target.matches('[data-drawing-select]')) {
      const apply = story.querySelector('[data-sp-apply-size]');
      if (apply) apply.disabled = !/^\d+$/.test(event.target.value);
      const note = story.querySelector('[data-sp-apply-note]');
      if (note) note.hidden = true;
    }
  });
  const apply = story.querySelector('[data-sp-apply-size]');
  if (apply) {
    apply.hidden = false;
    apply.disabled = !/^\d+$/.test(story.querySelector('[data-drawing-select]').value);
    apply.addEventListener('click', () => {
      const size = story.querySelector('[data-drawing-select]').value;
      const input = Array.from(variantSelector()?.querySelectorAll('input[type="radio"]') || []).find(item => item.value.replace(/["″]/g,'').trim() === size);
      const note = story.querySelector('[data-sp-apply-note]');
      if (!input || input.disabled) {
        if (note) { note.textContent = apply.dataset.unavailable; note.hidden = false; }
        return;
      }
      // The native change handler owns price, URL, stock, media and cart variant ID.
      input.click();
      if (note) { note.textContent = apply.dataset.requested; note.hidden = false; }
      const destination = input.closest('fieldset') || input;
      destination.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'center'});
      input.focus({preventScroll:true});
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href="#sp-3c-fit"]');
    if (!link) return;
    const enquiry = story.querySelector('.sp-story__enquiry');
    if (!enquiry) return;
    enquiry.open = true;
    const setIfUntouched = (name,value) => {
      if (!value) return;
      const field = enquiry.querySelector('[name="contact[' + name + ']"]');
      if (field && field.dataset.spEdited !== 'true' && (!field.value || field.dataset.spPrefilled === 'true')) {
        field.value = value;
        field.dataset.spPrefilled = 'true';
      }
    };
    const sizeIndex = Number(productInfo?.querySelector('[data-sp-delivery]')?.dataset.sizeIndex ?? 0);
    const rawSize = link.closest('sp-floor-drawings')
      ? story.querySelector('[data-drawing-select]')?.value
      : selectedOptions()[sizeIndex];
    const size = (rawSize || '').replace(/["″]/g, '').trim();
    setIfUntouched('Size', size === 'CUSTOM' ? 'Custom size' : size ? size + '″' : '');
    const projector = story.querySelector('[data-fit-projector]:checked')?.value;
    setIfUntouched('Projector type', projector || '');
    const light = story.querySelector('[data-fit-light]:checked')?.value;
    setIfUntouched('Room', light === 'bright' ? 'bright' : light === 'controlled' ? 'dim' : '');
    const note = enquiry.querySelector('[data-sp-prefill-note]');
    if (note) note.hidden = false;
  });
})();

